import http from "@/services/http"

export function getInstrumentsForAssignment(organizationsGroupId, year, subOperationId) {
  return http.get(`organization-instruments/organizations-group/${organizationsGroupId}/work?year=${year}&subOperationId=${subOperationId}`)
}
export function getForAssignment(body) {
  return http.post("instruments/forAssignment", body)
}


export default {
  getForAssignment,
}
